import styled from '@emotion/styled';
import { Button } from '../../../../../components-dummy';

export const DeleteRuleGroupButtonStyled = styled(Button)`
  min-width: 57px;
  height: 24px;
  padding: 0;
`;
